import React from 'react';
import {CategorySliderLoading} from '../../features/CategorySlider/CategorySliderLoading';
import {FiltersHeaderLoading} from '../../features/Filters/FiltersHeader/FiltersHeaderLoading';

export const CategoryStreamSkeletonMobile: React.FC = () => {
  return (
    <>
      <FiltersHeaderLoading />
      <CategorySliderLoading />
    </>
  );
};
